import { useLocation } from "react-router-dom";
import servicosImagens from "../../servicos/servicos-imagens";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import AuthContext from "../../servicos/autorizacao/AuthContex";
import servicosProduto from "../../servicos/servicos-produto";
import servicosColaborador from "../../servicos/servicos-colaborador";
import { ToastContainer, toast } from "react-toastify";
import NavMobile from "./NavMobile";
import { basePath } from "../../utils/baseUrl";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const CardProdutoProducao = () => {
    const { user } = useContext(AuthContext);
    const [listaTamanhos, setListaTamanhos] = useState([]);
    const location = useLocation();
    const produto = location.state.produto;
    const [todosProdutos, setTodosProdutos] = useState([]);
    const [imagensProduto, setImagensProduto] = useState([]);
    const [imagemSelecionada, setImagemSelecionada] = useState(`${basePath}/${produto.filename}` || `${basePath}/${location.state.produto.filename}`);
    const [pontucaoExterna, setPontuacaoExterna] = useState([]);
    const qtd = useRef();
    const tamanho = useRef();

    useEffect(() => {
        servicosColaborador.getTotalPontosExternos(user.id).then(response => {
            if (response.status === 200) {
                setPontuacaoExterna(response.data);
            }
        }).catch(e => console.log(e))
    }, [user.id])

    useEffect(() => {
        const lista = [];
        servicosProduto.listarTodosCategoria2().then(response => {
            if (response.status === 200) {
                for (const item of response.data) {
                    if (item.nome === produto.Produto[0].nome && item.estoque > 0 && item.tamanho !== '') {
                        lista.push(item);
                    }
                }
                setListaTamanhos(lista);
                setTodosProdutos(response.data)
            }
        })
    }, [produto]);



    useEffect(() => {
        servicosImagens.listarPorIdProduto(produto.id_produto).then(response => {
            if (response.status === 200) {
                setImagensProduto(response.data);
            }
        }).catch(e => console.log(e));
    }, [produto.id_produto]);



    const SelectTamanho = () => {

        if (listaTamanhos.length > 0) {
            return <>
                <select className="form-select w-25 mb-4" ref={tamanho} aria-label="Exemplo de select simples">
                    {listaTamanhos.map(item => {
                        return (
                            <option key={item.tamanho}>{item.tamanho}</option>
                        )
                    })}
                </select>
            </>
        }
    }


    async function adicionarAoCarrinho(produto) {

        let flagMax = false;
        if (tamanho?.current?.value !== undefined) {
            todosProdutos.map(item => {
                if (item.nome === produto.produto.Produto[0].nome && item.tamanho === tamanho?.current?.value) {
                    if (item.estoque >= qtd.current.value) {
                        produto.produto.id_produto = item.id_produto;
                        produto.produto.Produto[0] = item;
                        return produto;
                    } else {
                        flagMax = true;
                        return toast.warning('Quantidade informada ultrapassa o estoque atual');
                    }
                } else {
                    return null
                }
            })
        }

        if (!flagMax) {
            if (qtd.current.value <= produto.produto.Produto[0].estoque) {
                let carrinho = await JSON.parse(localStorage.getItem('carrinho_producao')) || { produtos: [] };
                let produtoEncontrado = await carrinho.produtos.find(item => item.produto.id_produto === produto.produto.id_produto);
                if (produtoEncontrado) {
                    produtoEncontrado.qtd += Number(produto.qtd);
                } else {
                    carrinho.produtos.push(produto);
                }
                toast.success(`Adicionado ${produto.produto.Produto[0].nome}  qtd: ${produto.qtd}`)
                localStorage.setItem('carrinho_producao', JSON.stringify(carrinho));
            } else {
                toast.warning('Quantidade informada ultrapassa o estoque atual')
            }
        }
    }


    return <>
        <ToastContainer />
        <div className="ms-2 mt-3 d-flex">
            <a style={{ fontSize: 22 }} className="me-3 subtitulo" href="/">Home</a>
            <a style={{ fontSize: 22 }} className="subtitulo" href="/SolicitacoesExterna">Menu Parceiro</a>
        </div>
        <div className="d-flex align-items-center justify-content-center card-produto container mt-4">
            <div style={{ width: 300, height: 650 }} className="shadow-sm card card-imagem d-flex justify-content-center col align-items-center">

                <div className="d-flex align-items-center row justify-content-center">
                    <span style={{ position: "absolute", marginLeft: 0, bottom: 0 }}>imagens ilustrativa</span>
                    <img style={{ width: 300 }} src={imagemSelecionada} className="card-img-top my-5 imagem-selecionada" alt="..." />
                </div>
                <div className="d-flex justify-content-center lista-imagens">
                    {imagensProduto.length > 1 && imagensProduto.map(item => {
                        return (<div key={item.filename} className={`border-1 border border-secondary mx-1 ${imagemSelecionada === `${basePath}/${item.filename}` ? 'item-selecionado' : ''} `}>
                            <img onClick={() => setImagemSelecionada(`${basePath}/${item.filename}`)} style={{ width: 150, height: 150 }} src={`${basePath}/${item.filename}`} alt={item.filename} />
                        </div>)
                    })}
                </div>
            </div>
            <div style={{ width: 300, height: 500 }} className="shadow-sm card card-detalhes d-flex justify-content-center align-items-center ">
                <div className="w-100 d-flex mt-3 justify-content-center align-items-center">
                    <span className="me-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#753BBD" className="bi bi-coin" viewBox="0 0 16 16">
                            <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z" />
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
                        </svg>{` ${pontucaoExterna.pontosAtivos}  milhas`}
                    </span>
                    <a href="/Carrinho">

                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#753BBD" className="bi bi-cart-check-fill" viewBox="0 0 16 16">
                            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z" />
                        </svg>Produção
                    </a>
                </div>
                <h5 className="card-title  subtitulo text-center">{produto.Produto[0].nome}</h5>
                <p className="card-text subtitulo2 text-center">{produto.Produto[0].milhas} milhas</p>
                <SelectTamanho />
                <div className="form-group d-flex justify-content-center align-items-center my-3 me-4">
                    Qtd: <input type="number" style={{ width: 60 }} min={0} ref={qtd} className="form-control btn-icones ms-1" defaultValue={1} id="qtd" aria-describedby="qtd" />
                </div>
                {produto?.Produto[0].estoque < 1 && listaTamanhos.length < 1 ? <span style={{color: 'red', fontSize: 16}}>Produto esgotado {<SentimentVeryDissatisfiedIcon sx={{mb: "4px"}} />}</span> : <button onClick={() => adicionarAoCarrinho({ produto: produto, qtd: Number(qtd?.current?.value) })} className="btn w-50 btn-icones btn-primary mb-4">
                    Adicionar ao carrinho de prod.
                </button>}

               

            </div>
        </div>
        <div className="text-center mt-5">
            <span><a href="/ShoppingProducao" className="subtitulo rounded-3 p-1">Conheça outros produtos</a></span>
        </div>
        <NavMobile />
    </>
}

export default CardProdutoProducao;